import React from "react";

const HeroADF = () => {
  return (
    <>
      <div className="st-height-b80 st-height-lg-b80" id="home"></div>
      <div
        id="home"
        className="st-hero-wrap st-color1 st-gray-bg overflow-hidden st-shape-wrap"
      >
        <div className="st-hero st-style2 text-center">
          <div className="st-hero-text">
            <h1 className="st-hero-title cd-headline clip">
              Account Deletion Form
            </h1>
          </div>
        </div>
      </div>
    </>
  );
};

export default HeroADF;
